import React, { useEffect } from "react";
import { Transition } from "@headlessui/react";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";

function Toast({ show, message, type, onHide }) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onHide]);

  // Icon per toast type. The icon carries the status color; the toast
  // background stays neutral (white / dark) regardless of type.
  const toastTypes = {
    success: {
      icon: CheckCircleIcon,
      iconColor: "text-success",
    },
    alert: {
      icon: ExclamationCircleIcon,
      iconColor: "text-alert",
    },
    danger: {
      icon: XCircleIcon,
      iconColor: "text-danger",
    },
    error: {
      icon: XCircleIcon,
      iconColor: "text-danger",
    },
    default: {
      icon: InformationCircleIcon,
      iconColor: "text-gray-400 dark:text-gray-500",
    },
  };

  const { icon: Icon, iconColor } = toastTypes[type] || toastTypes.default;

  return (
    <Transition
      show={show}
      as={React.Fragment}
      enter="transition ease-out duration-300"
      enterFrom="transform opacity-0 translate-y-full"
      enterTo="transform opacity-100 translate-y-0"
      leave="transition ease-in duration-200"
      leaveFrom="transform opacity-100"
      leaveTo="transform opacity-0"
    >
      <div
        role="alert"
        className="fixed bottom-0 left-1/2 -translate-x-1/2 mb-4 z-50 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 pl-4 pr-9 py-4 rounded-lg shadow-lg ring-1 ring-black/5 dark:ring-white/10 flex items-start min-w-[300px] max-w-[400px]"
      >
        {Icon && (
          <Icon className={`w-5 h-5 mr-3 mt-0.5 flex-shrink-0 ${iconColor}`} />
        )}
        <span className="text-sm leading-snug break-words">{message}</span>
        <button
          type="button"
          onClick={onHide}
          aria-label="Dismiss"
          className="absolute top-2 right-2 p-1 rounded-md text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-600"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      </div>
    </Transition>
  );
}

export { Toast };
